require("!!/code/frontend/node_modules/script-loader/addScript.js")(require("!!/code/frontend/node_modules/raw-loader/index.js!/code/frontend/node_modules/grapesjs-preset-newsletter/dist/grapesjs-preset-newsletter.min.js"))


//////////////////
// WEBPACK FOOTER
// /code/frontend/~/script-loader!/code/frontend/~/grapesjs-preset-newsletter/dist/grapesjs-preset-newsletter.min.js
// module id = ../../../../script-loader/index.js!../../../../grapesjs-preset-newsletter/dist/grapesjs-preset-newsletter.min.js
// module chunks = 3